<script>
  export let id;
  export let value = { id: undefined, name: null };
  export let current;
  export let label;
  export let icon = null;
  export let margin = true;
  export let values = [];
  export let reset = true;
  export let required = false;
  export let placeholder = "";
  export let textTransform = "none";

  let opened = false;

  const doReset = () => {
    value = { id: undefined, name: null };
  };

  const onChange = (e) => {
    value.id = null;
    opened = true;
  };

  const onFocus = (e) => {
    current = id;
    opened = true;
  };

  const onBlur = (e) => {
    current = null;
  };

  const onPickerSelect = (v) => {
    value.name = v;
    opened = false;
  };

  $: filtered = value.name ? filter(value.name.toLocaleLowerCase()) : values;

  const filter = (name) => {
    return values.filter((l) => l.name.toLocaleLowerCase().startsWith(name));
  };
</script>

<div class="form-group" class:in={current === id} class:filled={value.name} class:margin>
  <!-- label -->
  <label class="sr-only" required for={id}>{label}</label>

  <!-- icon -->
  {#if icon != null}
    <div class="icon-left choice">
      <i class={icon} />
    </div>
  {/if}

  <input
    class="form-control"
    bind:value={value.name}
    on:focus={onFocus}
    on:blur={onBlur}
    on:input={onChange}
    {required}
    type="text"
    name={id}
    {placeholder}
    autocomplete="off"
    style="text-transform:{textTransform};" />

  <!-- reset button -->
  {#if reset}
    <div class="icon-right reset">
      <button on:click={doReset} type="button" class="reset" tabindex="-1">
        <i class="fa fa-times-circle" />
      </button>
    </div>
  {/if}

  <!-- custom button -->
  <slot />

  <div class="picker" class:opened>
    {#each filtered as v}
      <label class="container">
        {v.name}
        <i class="far fa-hand-point-up" />
        <input
          type="radio"
          bind:group={value.id}
          value={v.id}
          on:change={() => onPickerSelect(v.name)}
          on:click={() => (opened = false)} />
      </label>
    {/each}
  </div>
</div>

<style>
  .form-group {
    display: flex;
    position: relative;
    width: 100%;
    border-radius: 2px;
    background: #efefef;
  }
  .margin.form-group {
    margin-bottom: 15px;
  }

  .readOnly.form-group {
    background: none;
  }

  .in.form-group {
    -webkit-box-shadow: 0 2px 0 var(--primary-light-color);
    box-shadow: 0 2px 0 var(--primary-light-color);
  }
  .in.form-group .icon-left {
    color: var(--primary-color);
  }
  .form-group .icon-left {
    width: 34px;
    padding-top: 10px;
    font-size: 17px;
    font-weight: 400;
    line-height: 1;
    text-align: right;
    background-color: #eee;
    border: 0;
    color: var(--primary-light-color);
  }

  .form-group .icon-right {
    background: 0;
    cursor: pointer;
    padding: 10px 8px 0 5px;
  }

  .form-group:not(.filled) div.reset {
    visibility: hidden !important;
  }

  .form-group .form-control {
    position: relative;
    width: 100%;
    margin-bottom: 0;
    background: #efefef;
  }

  .form-group input {
    -webkit-appearance: none;
    border: 0;
    border-radius: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #666;
    font-size: 14px;
    height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    resize: none;
    vertical-align: middle;
    width: 100%;
  }

  .form-group button {
    display: block;
  }

  .form-group button:not(:disabled):active {
    background-color: #efefef;
  }

  .form-group button.reset {
    cursor: pointer;
    background: none;
    color: #ccc;
    font-size: 18px;
    border: 0;
    border-radius: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    margin: 0;
    padding: 0;
    text-align: left;
  }

  .container {
    display: block;
    position: relative;
    background-color: white;
    border-radius: 15px;
    padding-left: 1em;
    padding-right: 1em;
    margin-right: 1em;
    font-size: 14px;
    line-height: 2em;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .container.checked {
    background-color: var(--primary-light-color);
  }

  /* Hide the browser's default radio button */
  .container input[type="radio"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .picker {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 40px;
    left: 22px;
    visibility: hidden;
    background-color: white;
    border: 1px solid var(--secondary-light-color);
  }

  .picker.opened {
    visibility: visible;
    z-index: 1;
  }
  .picker label {
    padding-left: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .picker label i {
    color: var(--primary-light-color);
  }
</style>
